
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/partnerships/submission-success",
      function () {
        return require("private-next-pages/about-us/partnerships/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/partnerships/submission-success"])
      });
    }
  